import Vue from 'vue'
import Vuex from 'vuex'
import { getPageConfig } from 'api/fed'
import 'plugins/ajax.js'
Vue.use(Vuex)

const state = {
  headerList: [],
  mobileHeaderList: [],
  activityList: [],
  gameList: [],
  serviceList: [],
  downloadConfig: {}
};

const getters = {
  headerList: state => state.headerList,
  mobileHeaderList: state => state.mobileHeaderList,
  activityList: state => state.activityList,
  gameList: state => state.gameList,
  serviceList: state => state.serviceList,
  downloadConfig: state => state.downloadConfig
};

const mutations = {
  updateBaseInfo (state, object) {
    state.headerList = object.header;
    state.mobileHeaderList = object.header_mobile;
    state.activityList = object.activity;
    state.gameList = object.game;
    state.serviceList = object.service;
    state.downloadConfig = object.main;
  }
};

const actions = {
  async getBaseInfo (context) {
    let baseConfig = await getPageConfig();
    context.commit('updateBaseInfo', baseConfig);
  }
};
export default new Vuex.Store({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
})
